<template>
  <div class="prontuario-medico-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Prontuario')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="tag.prontuarioMedico"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('prontuarioMedico')
            "
          >
            <template #value>
              <div v-if="tag.prontuarioMedico" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.medicalDocumentsURL + tag.prontuarioMedico
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
        <v-col v-if="$i18n.i18next.language === 'pt_br'" class="mb-4" cols="12">
          <field-section
            label="Número do SUS"
            :value="tag.numeroSus"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('numeroSus')
            "
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Medico_Particular')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Nome_Medico')"
            :value="tag.nomeMedico | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('nomeMedico')
            "
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Telefone_Medico')"
            :value="tag.foneMedico"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('foneMedico')
            "
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Empresa_Comp_Div')"
            :value="tag.empresaMedico | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('empresaMedico')
            "
          />
        </v-col>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Observacao')"
            :value="tag.observacao | capitalize({ onlyFirstLetter: true })"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('observacao')
            "
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Prontuario_Medico") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Prontuario_Medico"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
  },
};
</script>

<style scoped></style>
